<script setup lang="ts">
import { computed, ref, unref } from 'vue';

import { Button, Drawer } from '@apexx/component-library';

import HubSettingsPanel from './HubSettingsPanel.vue';

defineProps<{
	open: boolean;
}>();

const emit = defineEmits<{
	'update:open': [open: boolean];
}>();

const panelRef = ref<InstanceType<typeof HubSettingsPanel> | null>(null);

const isDirty = computed(() => Boolean(unref(panelRef.value?.isDirty)));
const isSaving = computed(() => Boolean(unref(panelRef.value?.isSaving)));

function onCancel(): void {
	panelRef.value?.cancel();
}

function onSave(): void {
	void panelRef.value?.save();
}
</script>

<template>
	<Drawer
		:open="open"
		placement="bottom"
		title="Settings"
		height="85vh"
		@update:open="emit('update:open', $event)"
	>
		<div class="px-1 pb-2">
			<HubSettingsPanel ref="panelRef" />
		</div>

		<template #footer>
			<div class="flex w-full gap-3">
				<Button
					variant="outline"
					class="flex-1"
					:disabled="isSaving"
					@click="onCancel"
				>
					Cancel
				</Button>
				<Button
					class="flex-1"
					:disabled="!isDirty || isSaving"
					@click="onSave"
				>
					{{ isSaving ? 'Saving…' : 'Save' }}
				</Button>
			</div>
		</template>
	</Drawer>
</template>
